import styled from 'styled-components';
import { MEDIUM_GRAY, GREEN, RED } from 'root/theme';
import { MdClose } from 'react-icons/md';
import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';

const ModalHeader = styled.div`
  box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);
  padding: 0 1rem 0 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
`;
ModalHeader.displayName = `ModalHeader`;

const CloseButton = styled(MdClose).attrs({
  fill: MEDIUM_GRAY,
  fontSize: `30px`,
})`
  margin-right: 20px;
  cursor: pointer;
`;
const HeaderTextAndImg = styled.div`
  display: flex;
  align-items: center;
  padding-left: 25px;
`;

const ModalHeaderText = styled.h3`
  padding-left: 1rem;
  margin: 0;
  font-weight: 600;
`;

const CustomModalCont = styled.div`
  width: 520px;
  background-color: white;
  text-align: center;
  padding-bottom: 2rem;
  border-radius: 30px;
  box-shadow: 0 0 0 1px rgba(0,0,0,.175), 0 3px 8px rgba(0,0,0,.175);
  max-height: calc(100% - 5rem);
  overflow: auto;
  @media(max-width: 520px) {
    width: calc(100% - 2rem);
  }
`;


const AllSetCircle = styled(FaCheckCircle).attrs({
  fill: GREEN,
})`
  font-size: 35px;
`;

const ErrorCircle = styled(FaExclamationCircle).attrs({
  fill: RED,
})`
  font-size: 35px;
`;

export {
  CustomModalCont,
  ModalHeaderText,
  ModalHeader,
  CloseButton,
  AllSetCircle,
  HeaderTextAndImg,
  ErrorCircle,
};
